import { Chats } from "../entities/getChat";
import { ChatRepository } from "../repositories/ChatRepository";

export class GetChats {
	constructor(private repository: ChatRepository) {}
	execute(): Promise<Chats[]> {
		return this.repository.getChats();
	}
}
